import apiClient from './apiClient';

const outlookService = {
    // OAuth (admin)
    getAuthUrl: () => apiClient.get('/outlook/admin/auth-url'),

    // Cuentas conectadas (admin)
    getCuentas: () => apiClient.get('/outlook/admin/cuentas'),
    desconectarCuenta: (idCredencial) => apiClient.delete(`/outlook/admin/cuentas/${idCredencial}`),

    // Suscriptores de una cuenta (admin)
    getSuscripciones: (idCredencial) => apiClient.get(`/outlook/admin/cuentas/${idCredencial}/suscripciones`),
    suscribir: (idCredencial, idUsuario) => apiClient.post(`/outlook/admin/cuentas/${idCredencial}/suscripciones/${idUsuario}`),
    desuscribir: (idCredencial, idUsuario) => apiClient.delete(`/outlook/admin/cuentas/${idCredencial}/suscripciones/${idUsuario}`),

    // Filtros por suscripción (admin)
    getFiltrosSuscripcion: (idCredencial, idSuscripcion) =>
        apiClient.get(`/outlook/admin/cuentas/${idCredencial}/suscripciones/${idSuscripcion}/filtros`),
    agregarFiltroSuscripcion: (idCredencial, idSuscripcion, tipo, valor) =>
        apiClient.post(`/outlook/admin/cuentas/${idCredencial}/suscripciones/${idSuscripcion}/filtros`, { tipo, valor }),
    eliminarFiltroSuscripcion: (idCredencial, idSuscripcion, idFiltro) =>
        apiClient.delete(`/outlook/admin/cuentas/${idCredencial}/suscripciones/${idSuscripcion}/filtros/${idFiltro}`),

    // Polling manual (admin)
    consultarAhora: () => apiClient.post('/outlook/admin/consultar-ahora'),

    // Autoservicio (cualquier usuario autenticado)
    getMiAuthUrl: () => apiClient.get('/outlook/mi-cuenta/auth-url'),
    getMisSuscripciones: () => apiClient.get('/outlook/mi-cuenta/suscripciones'),
    getMisFiltros: (idSuscripcion) => apiClient.get(`/outlook/mi-cuenta/suscripciones/${idSuscripcion}/filtros`),
    agregarMiFiltro: (idSuscripcion, tipo, valor) =>
        apiClient.post(`/outlook/mi-cuenta/suscripciones/${idSuscripcion}/filtros`, { tipo, valor }),
    eliminarMiFiltro: (idSuscripcion, idFiltro) =>
        apiClient.delete(`/outlook/mi-cuenta/suscripciones/${idSuscripcion}/filtros/${idFiltro}`),
};

export default outlookService;
